export const usersTableColumns = [
  {
    prop: 'avatar_url',
    title: 'common.fields.avatar',
    width: '5%',
    sortingEnabled: false,
  },
  {
    prop: 'is_active',
    title: 'common.filters.active',
    width: '5.97%',
    sortingEnabled: true,
  },
  {
    prop: 'fullname',
    title: 'common.fields.name',
    width: '23.23%',
    sortingEnabled: true,
  },
  {
    prop: 'email',
    title: 'common.fields.contacts',
    width: '40.04%',
    sortingEnabled: true,
  },
  {
    prop: 'last_login',
    title: 'adm.users.table_header.last_login',
    width: '16.69%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '9.07%',
    sortingEnabled: false,
  },
];
